




































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Media } from "@/types";
import draggable from "vuedraggable";
import Autocomplete from "@/components/AnimeSelector/Autocomplete.vue";

@Component({
  components: { Autocomplete, draggable }
})
export default class AnimeSelectorEvent extends Vue {
  @Prop() value!: Media[];

  get media() {
    return this.value;
  }

  set media(media: Media[]) {
    for (const m of media) {
      if (!m.EventMedia) {
        m.EventMedia = { episode: 1, episodes: 1, order: 0 };
      }
    }
    this.$emit("input", media);
  }

  setEpisodes(media: Media, event: number[]) {
    if (media.episodes && event[0] > media.episodes) {
      event[0] = media.episodes;
    } else if (!media.episodes && event[0] > 30) {
      event[0] = 30;
    }
    if (media.EventMedia) {
      if (media.EventMedia.episode !== event[0]) {
        if (media.EventMedia.episodes !== event[1] - media.EventMedia.episode) {
          media.EventMedia.episodes = event[1] - event[0];
        }
        media.EventMedia.episode = event[0];
      } else {
        media.EventMedia.episodes = event[1] - event[0];
        if (media.EventMedia.episodes <= 0) {
          media.EventMedia.episodes = 1;
        }
      }
      event[0] = media.EventMedia.episode;
      event[1] = media.EventMedia.episode + media.EventMedia.episodes;
    }
  }
}
